import { render } from "./Image.vue?vue&type=template&id=5c0256fa&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5c0256fa"

export default script